export default {"src":"/_next/static/media/csp.63410ceb.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};